/**
 * The locales that have been generated.
 */
export type AddressingLocale =
    | 'en-UK'
    | 'nl-NL'
    | 'fr-FR'
    | 'de-DE'
    | 'es-ES'
    | 'it-IT'

/**
 * The keys used to identify the generated locales.
 */
export type AddressingLocaleKey =
    | 'en'
    | 'nl'
    | 'fr'
    | 'de'
    | 'es'
    | 'it'

/**
 * The names that can be used to identify a generated locale for the adressing library.
 */
export type AddressingLocaleName =
    | 'en'
    | 'en-UK'
    | 'en-US'
    | 'nl'
    | 'nl-NL'
    | 'nl-BE'
    | 'fr'
    | 'fr-FR'
    | 'fr-BE'
    | 'de'
    | 'de-DE'
    | 'de-CH'
    | 'es'
    | 'es-ES'
    | 'it'
    | 'it-IT'
    | 'it-CH'

/**
 * The available country codes in the addressing library.
 */
export enum AddressingCountryCode {
    AF = "AF",
    AX = "AX",
    AL = "AL",
    DZ = "DZ",
    AS = "AS",
    AD = "AD",
    AO = "AO",
    AI = "AI",
    AQ = "AQ",
    AG = "AG",
    AR = "AR",
    AM = "AM",
    AW = "AW",
    AC = "AC",
    AU = "AU",
    AT = "AT",
    AZ = "AZ",
    BS = "BS",
    BH = "BH",
    BD = "BD",
    BB = "BB",
    BY = "BY",
    BE = "BE",
    BZ = "BZ",
    BJ = "BJ",
    BM = "BM",
    BT = "BT",
    BO = "BO",
    BA = "BA",
    BW = "BW",
    BV = "BV",
    BR = "BR",
    IO = "IO",
    VG = "VG",
    BN = "BN",
    BG = "BG",
    BF = "BF",
    BI = "BI",
    KH = "KH",
    CM = "CM",
    CA = "CA",
    IC = "IC",
    CV = "CV",
    BQ = "BQ",
    KY = "KY",
    CF = "CF",
    EA = "EA",
    TD = "TD",
    CL = "CL",
    CN = "CN",
    CX = "CX",
    CP = "CP",
    CC = "CC",
    CO = "CO",
    KM = "KM",
    CG = "CG",
    CD = "CD",
    CK = "CK",
    CR = "CR",
    CI = "CI",
    HR = "HR",
    CU = "CU",
    CW = "CW",
    CY = "CY",
    CZ = "CZ",
    DK = "DK",
    DG = "DG",
    DJ = "DJ",
    DM = "DM",
    DO = "DO",
    EC = "EC",
    EG = "EG",
    SV = "SV",
    GQ = "GQ",
    ER = "ER",
    EE = "EE",
    SZ = "SZ",
    ET = "ET",
    FK = "FK",
    FO = "FO",
    FJ = "FJ",
    FI = "FI",
    FR = "FR",
    GF = "GF",
    PF = "PF",
    TF = "TF",
    GA = "GA",
    GM = "GM",
    GE = "GE",
    DE = "DE",
    GH = "GH",
    GI = "GI",
    GR = "GR",
    GL = "GL",
    GD = "GD",
    GP = "GP",
    GU = "GU",
    GT = "GT",
    GG = "GG",
    GN = "GN",
    GW = "GW",
    GY = "GY",
    HT = "HT",
    HM = "HM",
    HN = "HN",
    HK = "HK",
    HU = "HU",
    IS = "IS",
    IN = "IN",
    ID = "ID",
    IR = "IR",
    IQ = "IQ",
    IE = "IE",
    IM = "IM",
    IL = "IL",
    IT = "IT",
    JM = "JM",
    JP = "JP",
    JE = "JE",
    JO = "JO",
    KZ = "KZ",
    KE = "KE",
    KI = "KI",
    XK = "XK",
    KW = "KW",
    KG = "KG",
    LA = "LA",
    LV = "LV",
    LB = "LB",
    LS = "LS",
    LR = "LR",
    LY = "LY",
    LI = "LI",
    LT = "LT",
    LU = "LU",
    MO = "MO",
    MG = "MG",
    MW = "MW",
    MY = "MY",
    MV = "MV",
    ML = "ML",
    MT = "MT",
    MH = "MH",
    MQ = "MQ",
    MR = "MR",
    MU = "MU",
    YT = "YT",
    MX = "MX",
    FM = "FM",
    MD = "MD",
    MC = "MC",
    MN = "MN",
    ME = "ME",
    MS = "MS",
    MA = "MA",
    MZ = "MZ",
    MM = "MM",
    NA = "NA",
    NR = "NR",
    NP = "NP",
    NL = "NL",
    NC = "NC",
    NZ = "NZ",
    NI = "NI",
    NE = "NE",
    NG = "NG",
    NU = "NU",
    NF = "NF",
    KP = "KP",
    MK = "MK",
    MP = "MP",
    NO = "NO",
    OM = "OM",
    PK = "PK",
    PW = "PW",
    PS = "PS",
    PA = "PA",
    PG = "PG",
    PY = "PY",
    PE = "PE",
    PH = "PH",
    PN = "PN",
    PL = "PL",
    PT = "PT",
    PR = "PR",
    QA = "QA",
    RE = "RE",
    RO = "RO",
    RU = "RU",
    RW = "RW",
    WS = "WS",
    SM = "SM",
    ST = "ST",
    SA = "SA",
    SN = "SN",
    RS = "RS",
    SC = "SC",
    SL = "SL",
    SG = "SG",
    SX = "SX",
    SK = "SK",
    SI = "SI",
    SB = "SB",
    SO = "SO",
    ZA = "ZA",
    GS = "GS",
    KR = "KR",
    SS = "SS",
    ES = "ES",
    LK = "LK",
    BL = "BL",
    SH = "SH",
    KN = "KN",
    LC = "LC",
    MF = "MF",
    PM = "PM",
    VC = "VC",
    SD = "SD",
    SR = "SR",
    SJ = "SJ",
    SE = "SE",
    CH = "CH",
    SY = "SY",
    TW = "TW",
    TJ = "TJ",
    TZ = "TZ",
    TH = "TH",
    TL = "TL",
    TG = "TG",
    TK = "TK",
    TO = "TO",
    TT = "TT",
    TA = "TA",
    TN = "TN",
    TR = "TR",
    TM = "TM",
    TC = "TC",
    TV = "TV",
    UM = "UM",
    VI = "VI",
    UG = "UG",
    UA = "UA",
    AE = "AE",
    GB = "GB",
    US = "US",
    UY = "UY",
    UZ = "UZ",
    VU = "VU",
    VA = "VA",
    VE = "VE",
    VN = "VN",
    WF = "WF",
    EH = "EH",
    YE = "YE",
    ZM = "ZM",
    ZW = "ZW",
}

/**
 * Possible currency code from the addressing library.
 */
export type AddressingCurrencyCode =
    | 'AFN'
    | 'EUR'
    | 'ALL'
    | 'DZD'
    | 'USD'
    | 'AOA'
    | 'XCD'
    | 'ARS'
    | 'AMD'
    | 'AWG'
    | 'SHP'
    | 'AUD'
    | 'AZN'
    | 'BSD'
    | 'BHD'
    | 'BDT'
    | 'BBD'
    | 'BYN'
    | 'BZD'
    | 'XOF'
    | 'BMD'
    | 'BTN'
    | 'BOB'
    | 'BAM'
    | 'BWP'
    | 'NOK'
    | 'BRL'
    | 'GBP'
    | 'BND'
    | 'BGN'
    | 'BIF'
    | 'KHR'
    | 'XAF'
    | 'CAD'
    | 'CVE'
    | 'KYD'
    | 'CLP'
    | 'CNY'
    | 'COP'
    | 'KMF'
    | 'CDF'
    | 'NZD'
    | 'CRC'
    | 'CUC'
    | 'ANG'
    | 'CZK'
    | 'DKK'
    | 'DJF'
    | 'DOP'
    | 'EGP'
    | 'ERN'
    | 'SZL'
    | 'ETB'
    | 'FKP'
    | 'FJD'
    | 'XPF'
    | 'GMD'
    | 'GEL'
    | 'GHS'
    | 'GIP'
    | 'GTQ'
    | 'GNF'
    | 'GYD'
    | 'HNL'
    | 'HKD'
    | 'HUF'
    | 'ISK'
    | 'INR'
    | 'IDR'
    | 'IRR'
    | 'IQD'
    | 'ILS'
    | 'JMD'
    | 'JPY'
    | 'JOD'
    | 'KZT'
    | 'KES'
    | 'KWD'
    | 'KGS'
    | 'LAK'
    | 'LBP'
    | 'LSL'
    | 'LRD'
    | 'LYD'
    | 'CHF'
    | 'MOP'
    | 'MGA'
    | 'MWK'
    | 'MYR'
    | 'MVR'
    | 'MRU'
    | 'MUR'
    | 'MXN'
    | 'MDL'
    | 'MNT'
    | 'MAD'
    | 'MZN'
    | 'MMK'
    | 'NAD'
    | 'NPR'
    | 'NIO'
    | 'NGN'
    | 'KPW'
    | 'MKD'
    | 'OMR'
    | 'PKR'
    | 'PGK'
    | 'PYG'
    | 'PEN'
    | 'PHP'
    | 'PLN'
    | 'QAR'
    | 'RON'
    | 'RUB'
    | 'RWF'
    | 'WST'
    | 'STN'
    | 'SAR'
    | 'RSD'
    | 'SCR'
    | 'SLE'
    | 'SGD'
    | 'SBD'
    | 'SOS'
    | 'ZAR'
    | 'KRW'
    | 'SSP'
    | 'LKR'
    | 'SDG'
    | 'SRD'
    | 'SEK'
    | 'SYP'
    | 'TWD'
    | 'TJS'
    | 'TZS'
    | 'THB'
    | 'TOP'
    | 'TTD'
    | 'TND'
    | 'TRY'
    | 'TMT'
    | 'UGX'
    | 'UAH'
    | 'AED'
    | 'UYU'
    | 'UZS'
    | 'VUV'
    | 'VES'
    | 'VND'
    | 'YER'
    | 'ZMW'

/**
 * Possible three-letter country codes from the addressing library.
 */
export type AddressingThreeLetterCountryCode =
    | 'AFG'
    | 'ALA'
    | 'ALB'
    | 'DZA'
    | 'ASM'
    | 'AND'
    | 'AGO'
    | 'AIA'
    | 'ATA'
    | 'ATG'
    | 'ARG'
    | 'ARM'
    | 'ABW'
    | 'ASC'
    | 'AUS'
    | 'AUT'
    | 'AZE'
    | 'BHS'
    | 'BHR'
    | 'BGD'
    | 'BRB'
    | 'BLR'
    | 'BEL'
    | 'BLZ'
    | 'BEN'
    | 'BMU'
    | 'BTN'
    | 'BOL'
    | 'BIH'
    | 'BWA'
    | 'BVT'
    | 'BRA'
    | 'IOT'
    | 'VGB'
    | 'BRN'
    | 'BGR'
    | 'BFA'
    | 'BDI'
    | 'KHM'
    | 'CMR'
    | 'CAN'
    | 'CPV'
    | 'BES'
    | 'CYM'
    | 'CAF'
    | 'TCD'
    | 'CHL'
    | 'CHN'
    | 'CXR'
    | 'CPT'
    | 'CCK'
    | 'COL'
    | 'COM'
    | 'COG'
    | 'COD'
    | 'COK'
    | 'CRI'
    | 'CIV'
    | 'HRV'
    | 'CUB'
    | 'CUW'
    | 'CYP'
    | 'CZE'
    | 'DNK'
    | 'DGA'
    | 'DJI'
    | 'DMA'
    | 'DOM'
    | 'ECU'
    | 'EGY'
    | 'SLV'
    | 'GNQ'
    | 'ERI'
    | 'EST'
    | 'SWZ'
    | 'ETH'
    | 'FLK'
    | 'FRO'
    | 'FJI'
    | 'FIN'
    | 'FRA'
    | 'GUF'
    | 'PYF'
    | 'ATF'
    | 'GAB'
    | 'GMB'
    | 'GEO'
    | 'DEU'
    | 'GHA'
    | 'GIB'
    | 'GRC'
    | 'GRL'
    | 'GRD'
    | 'GLP'
    | 'GUM'
    | 'GTM'
    | 'GGY'
    | 'GIN'
    | 'GNB'
    | 'GUY'
    | 'HTI'
    | 'HMD'
    | 'HND'
    | 'HKG'
    | 'HUN'
    | 'ISL'
    | 'IND'
    | 'IDN'
    | 'IRN'
    | 'IRQ'
    | 'IRL'
    | 'IMN'
    | 'ISR'
    | 'ITA'
    | 'JAM'
    | 'JPN'
    | 'JEY'
    | 'JOR'
    | 'KAZ'
    | 'KEN'
    | 'KIR'
    | 'XKK'
    | 'KWT'
    | 'KGZ'
    | 'LAO'
    | 'LVA'
    | 'LBN'
    | 'LSO'
    | 'LBR'
    | 'LBY'
    | 'LIE'
    | 'LTU'
    | 'LUX'
    | 'MAC'
    | 'MDG'
    | 'MWI'
    | 'MYS'
    | 'MDV'
    | 'MLI'
    | 'MLT'
    | 'MHL'
    | 'MTQ'
    | 'MRT'
    | 'MUS'
    | 'MYT'
    | 'MEX'
    | 'FSM'
    | 'MDA'
    | 'MCO'
    | 'MNG'
    | 'MNE'
    | 'MSR'
    | 'MAR'
    | 'MOZ'
    | 'MMR'
    | 'NAM'
    | 'NRU'
    | 'NPL'
    | 'NLD'
    | 'NCL'
    | 'NZL'
    | 'NIC'
    | 'NER'
    | 'NGA'
    | 'NIU'
    | 'NFK'
    | 'PRK'
    | 'MKD'
    | 'MNP'
    | 'NOR'
    | 'OMN'
    | 'PAK'
    | 'PLW'
    | 'PSE'
    | 'PAN'
    | 'PNG'
    | 'PRY'
    | 'PER'
    | 'PHL'
    | 'PCN'
    | 'POL'
    | 'PRT'
    | 'PRI'
    | 'QAT'
    | 'REU'
    | 'ROU'
    | 'RUS'
    | 'RWA'
    | 'WSM'
    | 'SMR'
    | 'STP'
    | 'SAU'
    | 'SEN'
    | 'SRB'
    | 'SYC'
    | 'SLE'
    | 'SGP'
    | 'SXM'
    | 'SVK'
    | 'SVN'
    | 'SLB'
    | 'SOM'
    | 'ZAF'
    | 'SGS'
    | 'KOR'
    | 'SSD'
    | 'ESP'
    | 'LKA'
    | 'BLM'
    | 'SHN'
    | 'KNA'
    | 'LCA'
    | 'MAF'
    | 'SPM'
    | 'VCT'
    | 'SDN'
    | 'SUR'
    | 'SJM'
    | 'SWE'
    | 'CHE'
    | 'SYR'
    | 'TWN'
    | 'TJK'
    | 'TZA'
    | 'THA'
    | 'TLS'
    | 'TGO'
    | 'TKL'
    | 'TON'
    | 'TTO'
    | 'TAA'
    | 'TUN'
    | 'TUR'
    | 'TKM'
    | 'TCA'
    | 'TUV'
    | 'UMI'
    | 'VIR'
    | 'UGA'
    | 'UKR'
    | 'ARE'
    | 'GBR'
    | 'USA'
    | 'URY'
    | 'UZB'
    | 'VUT'
    | 'VAT'
    | 'VEN'
    | 'VNM'
    | 'WLF'
    | 'ESH'
    | 'YEM'
    | 'ZMB'
    | 'ZWE'

/**
 * Possible country code from the addressing library.
 */
export type AddressingNumericCountryCode =
    | '004'
    | '248'
    | '008'
    | '012'
    | '016'
    | '020'
    | '024'
    | '660'
    | '010'
    | '028'
    | '032'
    | '051'
    | '533'
    | '036'
    | '040'
    | '031'
    | '044'
    | '048'
    | '050'
    | '052'
    | '112'
    | '056'
    | '084'
    | '204'
    | '060'
    | '064'
    | '068'
    | '070'
    | '072'
    | '074'
    | '076'
    | '086'
    | '092'
    | '096'
    | '100'
    | '854'
    | '108'
    | '116'
    | '120'
    | '124'
    | '132'
    | '535'
    | '136'
    | '140'
    | '148'
    | '152'
    | '156'
    | '162'
    | '166'
    | '170'
    | '174'
    | '178'
    | '180'
    | '184'
    | '188'
    | '384'
    | '191'
    | '192'
    | '531'
    | '196'
    | '203'
    | '208'
    | '262'
    | '212'
    | '214'
    | '218'
    | '818'
    | '222'
    | '226'
    | '232'
    | '233'
    | '748'
    | '231'
    | '238'
    | '234'
    | '242'
    | '246'
    | '250'
    | '254'
    | '258'
    | '260'
    | '266'
    | '270'
    | '268'
    | '276'
    | '288'
    | '292'
    | '300'
    | '304'
    | '308'
    | '312'
    | '316'
    | '320'
    | '831'
    | '324'
    | '624'
    | '328'
    | '332'
    | '334'
    | '340'
    | '344'
    | '348'
    | '352'
    | '356'
    | '360'
    | '364'
    | '368'
    | '372'
    | '833'
    | '376'
    | '380'
    | '388'
    | '392'
    | '832'
    | '400'
    | '398'
    | '404'
    | '296'
    | '983'
    | '414'
    | '417'
    | '418'
    | '428'
    | '422'
    | '426'
    | '430'
    | '434'
    | '438'
    | '440'
    | '442'
    | '446'
    | '450'
    | '454'
    | '458'
    | '462'
    | '466'
    | '470'
    | '584'
    | '474'
    | '478'
    | '480'
    | '175'
    | '484'
    | '583'
    | '498'
    | '492'
    | '496'
    | '499'
    | '500'
    | '504'
    | '508'
    | '104'
    | '516'
    | '520'
    | '524'
    | '528'
    | '540'
    | '554'
    | '558'
    | '562'
    | '566'
    | '570'
    | '574'
    | '408'
    | '807'
    | '580'
    | '578'
    | '512'
    | '586'
    | '585'
    | '275'
    | '591'
    | '598'
    | '600'
    | '604'
    | '608'
    | '612'
    | '616'
    | '620'
    | '630'
    | '634'
    | '638'
    | '642'
    | '643'
    | '646'
    | '882'
    | '674'
    | '678'
    | '682'
    | '686'
    | '688'
    | '690'
    | '694'
    | '702'
    | '534'
    | '703'
    | '705'
    | '090'
    | '706'
    | '710'
    | '239'
    | '410'
    | '728'
    | '724'
    | '144'
    | '652'
    | '654'
    | '659'
    | '662'
    | '663'
    | '666'
    | '670'
    | '729'
    | '740'
    | '744'
    | '752'
    | '756'
    | '760'
    | '158'
    | '762'
    | '834'
    | '764'
    | '626'
    | '768'
    | '772'
    | '776'
    | '780'
    | '788'
    | '792'
    | '795'
    | '796'
    | '798'
    | '581'
    | '850'
    | '800'
    | '804'
    | '784'
    | '826'
    | '840'
    | '858'
    | '860'
    | '548'
    | '336'
    | '862'
    | '704'
    | '876'
    | '732'
    | '887'
    | '894'
    | '716'

/**
 * The field types of an address.
 */
export enum AddressField {
    ADMINISTRATIVE_AREA = "ADMINISTRATIVE_AREA",
    LOCALITY = "LOCALITY",
    DEPENDENT_LOCALITY = "DEPENDENT_LOCALITY",
    POSTAL_CODE = "POSTAL_CODE",
    SORTING_CODE = "SORTING_CODE",
    ADDRESS_LINE1 = "ADDRESS_LINE1",
    ADDRESS_LINE2 = "ADDRESS_LINE2",
    ORGANIZATION = "ORGANIZATION",
    GIVEN_NAME = "GIVEN_NAME",
    ADDITIONAL_NAME = "ADDITIONAL_NAME",
    FAMILY_NAME = "FAMILY_NAME",
}

/**
 * Way to interpret the locality field of an address format.
 */
export enum LocalityType {
    CITY = "CITY",
    DISTRICT = "DISTRICT",
    POST_TOWN = "POST_TOWN",
    SUBURB = "SUBURB",
}

/**
 * Way to interpret the dependent locality field of an address format.
 */
export enum DependentLocalityType {
    DISTRICT = "DISTRICT",
    NEIGHBORHOOD = "NEIGHBORHOOD",
    VILLAGE_TOWNSHIP = "VILLAGE_TOWNSHIP",
    SUBURB = "SUBURB",
    TOWNLAND = "TOWNLAND",
}

/**
 * Way to interpret the administrative area field of an address format.
 */
export enum AdministrativeAreaType {
    AREA = "AREA",
    CANTON = "CANTON",
    COUNTY = "COUNTY",
    DEPARTMENT = "DEPARTMENT",
    DISTRICT = "DISTRICT",
    DO_SI = "DO_SI",
    EMIRATE = "EMIRATE",
    ISLAND = "ISLAND",
    OBLAST = "OBLAST",
    PARISH = "PARISH",
    PREFECTURE = "PREFECTURE",
    PROVINCE = "PROVINCE",
    STATE = "STATE",
}

/**
 * Way to interpret the postal code field of an address format.
 */
export enum PostalCodeType {
    EIR = "EIR",
    PIN = "PIN",
    POSTAL = "POSTAL",
    ZIP = "ZIP",
}

export enum FieldOverride {
    HIDDEN = "HIDDEN",
    OPTIONAL = "OPTIONAL",
    REQUIRED = "REQUIRED",
}

/**
 * Country metadata as generated from the addressing library. Does not contain localization data.
 */
export type AddressingCountryMetadata = {
    countryCode: AddressingCountryCode;
    threeLetterCode: AddressingThreeLetterCountryCode | null;
    numericCode: AddressingNumericCountryCode | null;
    currencyCode: AddressingCurrencyCode | null;
    timeZones: string[];
    addressFormat: AddressFormatMetadata;
    subdivisions: SubdivisionMetadata[];
};

export type SubdivisionMetadata = {
    parent: SubdivisionMetadata | null;
    name: string;
    code: string;
    localCode: string | null;
    isoCode: string | null;
    hasChildren: boolean;
};

/**
 * Metadata that describes how the address of a country should be formatted.
 */
export type AddressFormatMetadata = {
    format: string;
    localFormat: string | null;
    usedFields: AddressField[];
    usedSubdivisionFields: AddressField[];
    requiredFields: AddressField[];
    uppercaseFields: AddressField[];
    administrativeAreaType: AdministrativeAreaType | null;
    localityType: LocalityType | null;
    dependentLocalityType: DependentLocalityType | null;
    postalCodeType: PostalCodeType | null;
    postalCodePattern: string | null;
    postalCodePrefix: string | null;
    subdivisionDepth: number;
}